export const firebaseConfig = {
  apiKey: "AIzaSyCbmTdN0zzRzOHJ13847v-tzA6Qw0Oc_bk",
  authDomain: "ra9ra9-dev.firebaseapp.com",
  projectId: "ra9ra9-dev",
  storageBucket: "ra9ra9-dev.appspot.com",
  messagingSenderId: "383964748904",
  appId: "1:383964748904:web:c0d0b6e66aebb11ec52fdd",
  measurementId: "G-VKNR9MG2XD",
}
